// Module
var code = "<p>交易附带的备注信息是使用备注公钥加密后传输的。为了解密备注信息，需要拥有备注公钥对应的私钥。</p> <p>备注信息由单独&lt;公/私钥对&gt;进行管理，如果账户资金权限与备注权限不一致或者此账户不拥有资金权限，你才可以安全的将此账户备注信息的只读权限交由第三方，这样才不会导致资金控制权外泄。</p> <p>警告：一般情况下，账户的资金权限与备注权限的&lt;公/私钥对&gt;相同，请不要轻易泄露备注权限的私钥，如需更改为不一致，请参考（账号登录模式）处说明。</p> ";
// Exports
export default code;